import "../styles/Header.css";
import banner from '../images/logos/Boughton-ShieldsCreationsLogo.jpg';

function MyHeader() {
  return (
      <header className="App-header">
        <img src={banner} className="logo-image" alt="Boughton-Shields Creations Banner" />
      </header>
  );
}

export default MyHeader;